import request from './request'

export function importDeveloperIaaDailyRecords(data) {
  return request({
    url: '/tiktok/developer/iaa/daily-records/import',
    method: 'post',
    withCredentials: false,
    data
  })
}

export function queryDeveloperIaaDailyRecords(params) {
  return request({
    url: '/tiktok/developer/iaa/daily-records',
    method: 'get',
    withCredentials: false,
    params
  })
}
